import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import CommonHeader from '../../util_components/common_header';
import SalesTaskForm from './form';
import './sales_task.css';

// Standalone task detail view, opened via /sales-task-form?uuid=…. The form
// draws its own cards (header, context, work panel) on the page background.
function SalesTaskFormPage() {
  const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const uuid = params.get('uuid') || '';
  // The header's "Sales tasks" link shows only when opened from the list page
  // (?from=list), not from the student profile popup.
  const from_list = params.get('from') === 'list';

  return (
    <div className="stl-root">
      <CommonHeader title="Sales Task" title_only />

      <div className="mx-[5%] my-5 max-sm:mx-3 max-sm:my-3">
        {/* key remounts the form per task: Done/Skip-and-Next pushes the same
            route with a new ?uuid, and without a remount the previous task's
            local state (review notes, attachments) bleeds into the next one.
            location.state.reopen (the hold banner's Reopen) remounts the same task. */}
        {uuid ? (
          <SalesTaskForm
            key={`${uuid}:${location.state?.reopen || ''}`}
            uuid={uuid}
            show_back_link={from_list}
          />
        ) : (
          <div className="flex flex-col items-start gap-2 rounded-[10px] border border-line-subtle bg-surface-card px-4 py-3 text-[13px] text-content-muted">
            {from_list ? (
              <Link to="/sales-task-list" className="text-xs font-medium text-content-link">
                ← Sales tasks
              </Link>
            ) : null}
            <span>
              Invalid link — a <code>uuid</code> query param is required.
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SalesTaskFormPage;
